// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2d006140","213":"3a4aa62b","453":"ee7dff6c","732":"39c2de15"}[chunkId] + ".chunk.js";
};